// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Link } from 'gatsby';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';
import Slider from '../../slider/slider';

// Utilities
import slugify from '../../../utilities/slugify';

// Styles
import MeetTheMatchmakersStyles from './meetTheMatchmakers.styles';

export default function MeetTheMatchmakers({ layout }) {
  const heading = layout?.heading;
  const text = layout?.text;
  const matchmakers = layout?.matchmakers;

  return (
    <MeetTheMatchmakersStyles>
      <Container>
        <header className="header">
          <h2 className="heading large">{heading}</h2>

          {text && <div className="text">{parse(text)}</div>}
        </header>

        {!!matchmakers && !!matchmakers.length && (
          <div className="content">
            <div className="wrapper">
              <Slider
                slides={2}
                gap={2}
                arrows
                breakpoints={{
                  375: {
                    slides: 2,
                    gap: 2,
                  },
                  768: {
                    slides: 3,
                    gap: 2,
                  },
                  992: {
                    slides: 4,
                    gap: 2,
                  },
                  1200: {
                    slides: 5,
                    gap: 2,
                  },
                  1920: {
                    slides: 5,
                    gap: 2,
                  },
                }}
              >
                {matchmakers.map((matchmaker) => (
                  <div key={uuid()}>
                    <div className="matchmaker">
                      <div className="top">
                        <Image
                          image={matchmaker?.featuredImage?.node}
                          filter={false}
                          className="headshot"
                        />

                        <div className="overlay" />
                      </div>
                      <div className="bottom">
                        <h3 className="name">{matchmaker?.title}</h3>
                        <h4 className="job-title">
                          {matchmaker?.teamMembers?.jobTitle}
                        </h4>
                        <Link
                          to={`/meet-our-experts?team-member=${slugify(
                            matchmaker?.title,
                          )}`}
                          className="btn text-only"
                        >
                          View Bio
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>

            <Link to="/meet-our-experts" className="btn dark">
              Meet the Team
            </Link>
          </div>
        )}
      </Container>
    </MeetTheMatchmakersStyles>
  );
}

MeetTheMatchmakers.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string,
    matchmakers: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

MeetTheMatchmakers.defaultProps = {
  layout: {},
};
